import { ErrorBoundary } from "@circle-react-shared/ErrorPages/ErrorBoundary";
import { ChatError } from "./ChatError";
import type { ListProps } from "./List";
import { List } from "./List";

export interface DMsListProps extends ListProps {}

export const DMsList = (props: DMsListProps) => (
  <ErrorBoundary renderFunc={ChatError}>
    <List {...props} />
  </ErrorBoundary>
);
